import { createSelector } from '@reduxjs/toolkit';
import { selectHouseGeo } from './selectHouseGeo';

export const selectTransportAccessibility = createSelector(selectHouseGeo, ({ undergrounds, highways, railways }) => ({
  undergrounds,
  highways,
  railways,
}));
